/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SecurityPolicyControllerCreatePolicyRequest { 
    scopeType: SecurityPolicyControllerCreatePolicyRequest.ScopeTypeEnum;
    scopeId?: string | null;
    requiresEmailVerification?: boolean | null;
    requires2fa?: boolean | null;
    /**
     * Permite passkeys. null = heredar; sin definir en ningún scope = no.
     */
    allowPasskeys?: boolean | null;
    /**
     * Dónde aplica la verificación de correo. null = todas / heredar.
     */
    emailVerificationPlatforms?: Array<SecurityPolicyControllerCreatePolicyRequest.EmailVerificationPlatformsEnum> | null;
}
export namespace SecurityPolicyControllerCreatePolicyRequest {
    export type ScopeTypeEnum = 'global' | 'job_category' | 'role' | 'user';
    export const ScopeTypeEnum = {
        Global: 'global' as ScopeTypeEnum,
        JobCategory: 'job_category' as ScopeTypeEnum,
        Role: 'role' as ScopeTypeEnum,
        User: 'user' as ScopeTypeEnum
    };
    export type EmailVerificationPlatformsEnum = 'web' | 'ios' | 'android';
    export const EmailVerificationPlatformsEnum = {
        Web: 'web' as EmailVerificationPlatformsEnum,
        Ios: 'ios' as EmailVerificationPlatformsEnum,
        Android: 'android' as EmailVerificationPlatformsEnum
    };
}


